import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import Select from 'react-select';
import { updatedProduct } from "../../../api/inventoryApi";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { getProduct } from "../../../slices/productSlice";

const EditProduct = ({ product, onClose }) => {
   const dispatch = useDispatch();
    
  // États pour les champs texte et numériques
  const [name, setName] = useState(product.name || '');
  const [qty, setQty] = useState(
    product.variations && product.variations.length > 0 ? product.variations[0].quantite : 0
  );
  const [qtyAlert, setQtyAlert] = useState(
    product.variations && product.variations.length > 0 ? product.variations[0].alerte_quantite : 0
  );
  const [prixVente, setPrixVente] = useState(
    product.variations && product.variations.length > 0 ? product.variations[0].prix_vente : ''
  );
  const [prixAchat, setPrixAchat] = useState(
    product.variations && product.variations.length > 0 ? product.variations[0].prix_achat : ''
  );
  const [expirationDate, setExpirationDate] = useState(
    product.variations && product.variations.length > 0 ? product.variations[0].expiration_date : ''
  );

  // États pour les sélections de catégorie et de stock
  const [selectedCategory, setSelectedCategory] = useState(
    product.category ? { value: product.category.id, label: product.category.name } : null
  );
  const [selectedStock, setSelectedStock] = useState(
    product.stock ? { value: product.stock, label: product.stock } : null
  );

  // État de chargement
  const [loading, setLoading] = useState(false);

    const showAlert = (config) => {
        Swal.fire({
            ...config,
            icon: config.type || "success",
            confirmButtonText: "OK",
        });
    };

  // Récupération des catégories depuis le store Redux
  const categoryData = useSelector((state) => state.products.categories);

  // Options pour le champ Stock
  const stockOptions = [
    { value: "Bar", label: "Bar" },
    { value: "Exposition", label: "Exposition" },
    { value: "Cuisine", label: "Cuisine" },
    { value: "Stock général", label: "Stock général" },
  ];

  // Options pour le champ Catégorie (basées sur les données du store)
  const categoryOptions = categoryData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  // Gestion de la soumission du formulaire (fonction asynchrone)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Création de l'objet mis à jour en reprenant les valeurs actuelles
     const  response = await updatedProduct({
        ...product,
        id: product.id,
        name,
        stock: selectedStock ? selectedStock.value : null,
        category: selectedCategory
          ? { ...product.category, id: selectedCategory.value, name: selectedCategory.label }
          : null,
        variations: product.variations && product.variations.length > 0
          ? [
              {
                ...product.variations[0],
                quantite: qty,
                alerte_quantite: qtyAlert,
                prix_vente: prixVente,
                prix_achat: prixAchat,
                expiration_date: expirationDate,
              },
            ]
          : [],
      });
      const products = response.data.products;
      dispatch(getProduct(products));
      showAlert({ text: "Produit modifié avec succès", type: "success" });
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Erreur lors de la modification.";
      showAlert({ text: errorMessage, type: "error" });
    } finally {
      setLoading(false);
    }

    // Fermeture du modal
    onClose();
  };

  return (
    <>
      {/* Modal d'édition du produit */}
      <div className="modal fade show" style={{ display: 'block' }} id="edit-stock" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Éditer un produit</h4>
                  </div>
                  <button type="button" className="close" onClick={onClose} aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                      <div className="col-lg-6">
                        <label className="form-label">Catégorie</label>
                        <Select
                          options={categoryOptions}
                          value={selectedCategory}
                          onChange={setSelectedCategory}
                          placeholder="Choisir une catégorie"
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Stock</label>
                        <Select
                          options={stockOptions}
                          value={selectedStock}
                          onChange={setSelectedStock}
                          placeholder="Choisir un stock"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Produit</label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="row mb-3">
                      <div className="col-lg-4">
                        <label className="form-label">Quantité</label>
                        <input
                          type="number"
                          readOnly
                          className="form-control"
                          value={qty}
                          onChange={(e) => setQty(Number(e.target.value))}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">Alerte Quantité</label>
                        <input
                          type="number"
                          className="form-control"
                          value={qtyAlert}
                          onChange={(e) => setQtyAlert(Number(e.target.value))}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="form-label">Prix de vente</label>
                        <input
                          type="text"
                          className="form-control"
                          value={prixVente}
                          onChange={(e) => setPrixVente(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-lg-6">
                        <label className="form-label">Prix d&apos;achat</label>
                        <input
                          type="text"
                          className="form-control"
                          value={prixAchat}
                          onChange={(e) => setPrixAchat(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Date d&apos;expiration</label>
                        <input
                          type="date"
                          className="form-control"
                          value={expirationDate}
                          onChange={(e) => setExpirationDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button type="button" className="btn btn-cancel me-2" onClick={onClose}>
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-submit" disabled={loading}>
                        {loading ? "Modif..." : "Modifier"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

EditProduct.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
    category: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    stock: PropTypes.string,
    name: PropTypes.string,
    variations: PropTypes.arrayOf(
      PropTypes.shape({
        alerte_quantite: PropTypes.number,
        quantite: PropTypes.number,
        prix_vente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        prix_achat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        expiration_date: PropTypes.string,
      })
    ),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditProduct;
